// src/site/pages/SiteImovel.jsx
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { useSite } from '../SiteContext';

export default function SiteImovel() {
  const { imovelId } = useParams();
  const { corretorId, ownerWhatsUrl } = useSite();
  const [imovel, setImovel] = useState(null);

  useEffect(() => {
    (async () => {
      if (!corretorId || !imovelId) return;

      // 1) Catálogo público (sanitizado)
      const catSnap = await getDoc(
        doc(db, 'siteCatalog', corretorId, 'imoveis', imovelId)
      );
      if (!catSnap.exists()) return;
      const base = { id: imovelId, ...catSnap.data() };
      setImovel(base);

      // 2) (Opcional) enriquecer com doc original se regras permitirem
      try {
        const fullSnap = await getDoc(doc(db, 'imoveis', imovelId));
        if (fullSnap.exists()) {
          setImovel((prev) => ({ ...prev, ...fullSnap.data() }));
        }
      } catch {
        // sem permissão? tudo bem, já temos o básico
      }
    })();
  }, [corretorId, imovelId]);

  if (!imovel) return null;

  const capa =
    imovel.imagens?.[0] || imovel.thumb || imovel.capaUrl || imovel.cover || '';

  const preco =
    typeof imovel.preco === 'number'
      ? `R$ ${imovel.preco.toLocaleString('pt-BR')}`
      : '';

  return (
    <div className="max-w-7xl mx-auto px-6 py-10">
      {/* Capa */}
      {capa && (
        <img
          src={capa}
          alt={imovel.tipo || 'Imóvel'}
          className="w-full h-[420px] object-cover rounded-xl"
        />
      )}

      {/* Infos principais */}
      <div className="mt-6">
        <h1 className="text-2xl font-semibold text-gray-900">
          {imovel.tipo} · {imovel.bairro} · {imovel.cidade}
        </h1>

        <p className="text-xl mt-2 font-bold text-gray-800">{preco}</p>
        <p className="text-gray-500 mt-1">
          Ref.: {imovel.refCodigo || imovel.referencia || '-'}
        </p>
      </div>

      {/* Botão de ação */}
      <div className="mt-8 flex gap-4">
        <button
          type="button"
          onClick={() =>
            ownerWhatsUrl &&
            window.open(ownerWhatsUrl, '_blank', 'noopener,noreferrer')
          }
          disabled={!ownerWhatsUrl}
          className={`px-6 py-3 rounded-xl font-medium text-white transition ${
            ownerWhatsUrl
              ? 'bg-blue-900 hover:bg-blue-800'
              : 'bg-slate-400 cursor-not-allowed'
          }`}
        >
          Conversar
        </button>
      </div>
    </div>
  );
}
